import React from 'react';
import { AppIcon } from './AppIcon.js';
import { Pay888Wordmark } from './AppLogo.js';
import { CardNetwork } from './CardNetwork.js';
import { CryptoIcon } from './CryptoIcon.js';
import { SERVICE_PREVIEWS } from '../features/services/catalog.js';

export const WalletBadges: React.FC = () => (
  <div className="wallet-brand-badges" aria-label="Mobile wallets on eligible cards">
    <span className="wallet-brand">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M17.05 12.54c.03 3.05 2.67 4.07 2.7 4.08-.02.07-.42 1.46-1.39 2.9-.84 1.25-1.72 2.5-3.09 2.52-1.35.03-1.79-.81-3.34-.81-1.55 0-2.03.79-3.32.84-1.32.05-2.32-1.36-3.17-2.6-1.73-2.5-3.05-7.07-1.28-10.16a4.93 4.93 0 0 1 4.18-2.53c1.31-.02 2.55.89 3.35.89.8 0 2.3-1.1 3.88-.94.66.03 2.5.27 3.69 2.02-.1.06-2.2 1.29-2.21 3.79ZM14.5 4.64c.71-.86 1.18-2.06 1.05-3.26-1.02.04-2.27.68-3 1.54-.66.75-1.24 1.96-1.09 3.11 1.15.09 2.33-.58 3.04-1.39Z"
        />
      </svg>
      Apple Pay
    </span>
    <span className="wallet-brand">
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <path
          fill="#4285f4"
          d="M43.6 24.5c0-1.4-.1-2.8-.4-4.1H24v7.8h11c-.5 2.5-1.9 4.6-4 6v5h6.5c3.8-3.5 6.1-8.6 6.1-14.7Z"
        />
        <path
          fill="#34a853"
          d="M24 44c5.4 0 10-1.8 13.5-4.8l-6.5-5c-1.8 1.2-4.1 1.9-7 1.9-5.2 0-9.7-3.5-11.3-8.2H6v5.2A20.4 20.4 0 0 0 24 44Z"
        />
        <path
          fill="#fbbc05"
          d="M12.7 27.9a12.3 12.3 0 0 1 0-7.8v-5.2H6a20 20 0 0 0 0 18.2l6.7-5.2Z"
        />
        <path
          fill="#ea4335"
          d="M24 11.9c3 0 5.6 1 7.7 3l5.8-5.8A19.4 19.4 0 0 0 24 4 20.4 20.4 0 0 0 6 14.9l6.7 5.2c1.6-4.7 6.1-8.2 11.3-8.2Z"
        />
      </svg>
      Google Pay
    </span>
  </div>
);

export const CryptoTokens: React.FC = () => (
  <div className="crypto-token-row" aria-label="Cryptocurrencies">
    <span className="crypto-token usdt-token">
      <CryptoIcon coin="tether" /> USDT
    </span>
    <span className="crypto-token">
      <CryptoIcon coin="bitcoin" /> Bitcoin
    </span>
  </div>
);

export const SpendingVisual: React.FC = () => (
  <div className="spending-visual" aria-label="Illustration: USDT funding a virtual card">
    <div className="visual-grid" />
    <span className="funding-coin" aria-hidden="true">
      <CryptoIcon coin="tether" size={60} />
    </span>
    <div className="funding-line" aria-hidden="true">
      <span />
    </div>
    <div className="mini-payment-card">
      <span>
        <span className="brand-lockup">
          <Pay888Wordmark width={70} mono />
        </span>
      </span>
      <strong>Your Name</strong>
      <small>•••• 8888 · SAMPLE</small>
      <CardNetwork network="mastercard" />
    </div>
    <div className="spending-wallet">
      <AppIcon name="phone" />
      <span>Online & mobile wallets</span>
    </div>
  </div>
);

export const PaymentLinkVisual: React.FC = () => (
  <div className="payment-link-visual" aria-label="Planned flow: payment link to USDT payout">
    <div className="visual-grid" />
    <div className="illustrated-request">
      <span className="icon-tile">
        <AppIcon name="link" />
      </span>
      <div>
        <strong>Payment request</strong>
        <small>pay888.app/your-name</small>
      </div>
    </div>
    <div className="illustrated-route">
      <span>Share your link</span>
      <AppIcon name="arrow" />
      <span className="usdt-label">
        <CryptoIcon coin="tether" size={22} /> USDT
      </span>
    </div>
  </div>
);

export const PaymentMethodPreview: React.FC = () => (
  <div className="payment-method-preview" aria-label="Planned card payment methods">
    <span>Pay by card</span>
    <CardNetwork network="visa" />
    <CardNetwork network="mastercard" />
    <span className="payment-example-label">Illustration only</span>
  </div>
);

export const ServicesVisual: React.FC = () => (
  <div className="services-visual" aria-label="All digital service previews">
    {SERVICE_PREVIEWS.map((item) => (
      <span className="service-visual-icon" key={item.id}>
        <AppIcon name={item.icon} />
        <span>{item.name}</span>
        <small>{item.example}</small>
        {item.category === 'Advanced' && <small>Under review</small>}
      </span>
    ))}
  </div>
);
